import React, { useState } from 'react';
import { auth, db } from '../firebase';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { doc, setDoc } from 'firebase/firestore';
import { useNavigate, Link } from 'react-router-dom';

const Signup = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', password: '', dob: '', captcha: '' });
  const [agreedLegal, setAgreedLegal] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [mathChallenge] = useState({ q: '5 + 3 = ?', a: '8' });

  // AUTO-GENERATOR WORD BANKS
  const adjectives = ['Iron', 'Cyber', 'Gold', 'Dark', 'Neon', 'Hyper', 'Solar', 'Mega', 'Rogue', 'Elite'];
  const nouns = ['Wolf', 'Titan', 'Coder', 'Eagle', 'Viper', 'Lion', 'Shark', 'Ghost', 'Baron', 'Pilot'];

  const generateHandle = () => {
    const adj = adjectives[Math.floor(Math.random() * adjectives.length)];
    const noun = nouns[Math.floor(Math.random() * nouns.length)];
    const num = Math.floor(1000 + Math.random() * 9000); // 4 digit number
    
    // SAFE STRING CONCATENATION (Fixes the syntax error)
    return adj + noun + num;
  };

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSignup = async (e) => {
    e.preventDefault();
    setError('');

    // AGE CHECK
    const birthDate = new Date(formData.dob);
    const age = Math.abs(new Date(Date.now() - birthDate.getTime()).getUTCFullYear() - 1970);
    if (age < 18) { setError('ACCESS DENIED: MINORS RESTRICTED.'); return; }
    
    // BOT CHECK
    if (formData.captcha.trim() !== mathChallenge.a) { setError('SECURITY ALERT: BOT DETECTED.'); return; }
    
    // LEGAL CHECK
    if (!agreedLegal) { setError('PROTOCOL HALTED: ACCEPT TERMS.'); return; }

    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      
      // GENERATE THE HANDLE
      const autoUsername = generateHandle();

      await setDoc(doc(db, 'users', userCredential.user.uid), {
        firstName: formData.firstName,
        lastName: formData.lastName,
        username: autoUsername, // Storing the generated handle
        email: formData.email,
        dob: formData.dob,
        tier: 'DREAMER', // Default tier
        createdAt: new Date().toISOString(),
        displayNameEnabled: true
      });

      navigate('/gatekeeper'); 
    } catch (err) {
      setError(err.message.replace('Firebase:', '').trim());
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>INITIATE ACCESS</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleSignup} style={styles.form}>
          <div style={styles.row}>
            <input name="firstName" placeholder="FIRST NAME" onChange={handleChange} required style={styles.halfInput} />
            <input name="lastName" placeholder="LAST NAME" onChange={handleChange} required style={styles.halfInput} />
          </div>
          <label style={styles.label}>DATE OF BIRTH (18+)</label>
          <input name="dob" type="date" onChange={handleChange} required style={styles.input} />
          <input name="email" type="email" placeholder="EMAIL" onChange={handleChange} required style={styles.input} />
          <input name="password" type="password" placeholder="PASSWORD" onChange={handleChange} required style={styles.input} />
          <div style={styles.row}>
            <div style={styles.captchaLabel}>SECURITY: {mathChallenge.q}</div>
            <input name="captcha" placeholder="?" onChange={handleChange} required style={{...styles.halfInput, textAlign:'center'}} />
          </div>
          <label style={styles.checkboxLabel}>
             <input type="checkbox" checked={agreedLegal} onChange={(e) => setAgreedLegal(e.target.checked)} style={styles.checkbox} />
             <span style={styles.checkText}>I accept the <Link to="/terms" style={styles.link}>Terms</Link> & <Link to="/legal" style={styles.link}>Legal</Link>.</span>
          </label>
          <button type="submit" disabled={loading} style={styles.button}>
            {loading ? 'PROCESSING...' : 'GRANT ACCESS'}
          </button>
        </form>
        <p style={{marginTop: '20px', fontSize: '0.8rem', color: '#666'}}>ALREADY IN? <Link to="/login" style={styles.link}>LOGIN</Link></p>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', background: '#000', color: '#fff' },
  card: { background: '#111', padding: '40px', borderRadius: '5px', border: '1px solid #333', width: '100%', maxWidth: '400px', textAlign: 'center' },
  title: { fontFamily: 'Orbitron', color: '#D4AF37', marginBottom: '20px' },
  form: { display: 'flex', flexDirection: 'column', gap: '15px' },
  row: { display: 'flex', gap: '10px', alignItems: 'center' },
  input: { padding: '15px', background: '#000', border: '1px solid #333', color: '#fff', width: '100%', boxSizing: 'border-box' },
  halfInput: { padding: '15px', background: '#000', border: '1px solid #333', color: '#fff', width: '100%', boxSizing: 'border-box' },
  label: { textAlign: 'left', fontSize: '0.7rem', color: '#666', marginBottom: '-10px' },
  captchaLabel: { color: '#D4AF37', fontFamily: 'Orbitron', fontWeight: 'bold' },
  checkboxLabel: { display: 'flex', gap: '10px', alignItems: 'center', fontSize: '0.8rem', color: '#999', textAlign: 'left' },
  checkbox: { accentColor: '#D4AF37' },
  button: { padding: '15px', background: '#D4AF37', border: 'none', fontWeight: 'bold', cursor: 'pointer', fontFamily: 'Orbitron' },
  error: { color: 'red', fontSize: '0.8rem', fontWeight: 'bold' },
  link: { color: '#D4AF37', textDecoration: 'none' }
};

export default Signup;
